/**
 * Central SEO config. Set REACT_APP_SITE_URL in .env for production (e.g. https://digitalfatehabad.com).
 * Used for canonical URLs, og:image absolute paths, and JSON-LD.
 */
export const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://digitalfatehabad.com';
export const SITE_NAME = 'Digital Fatehabad';
export const DEFAULT_DESCRIPTION = 'Discover 10,000+ local businesses, shops, and services in Fatehabad, Tohana, Ratia, Bhuna, and surrounding areas. Get verified contact numbers, addresses, opening hours, and reviews.';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/digi_fatehabad_logo.png`;
export const TWITTER_HANDLE = '@digitalfatehabad';
export const LOCALE = 'en_IN';
